import { Icon } from '@natera/material/lib/icon'
import { Collapsible } from 'radix-ui'
import { useState } from 'react'
import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import './collapsible-section.scss'

interface CollapsibleSectionProps {
  title: string
  searchQuery: string
  children: React.ReactNode
}

export function CollapsibleSection({ title, searchQuery, children }: CollapsibleSectionProps) {
  const [open, setOpen] = useState(true)

  return (
    <Collapsible.Root
      open={open}
      onOpenChange={setOpen}
      className="mt-2"
    >
      <Collapsible.Trigger className="flex w-full cursor-pointer items-center justify-between gap-1 border-none bg-transparent p-0 text-left outline-none">
        <Text appearance="CAPTION">{highlightText(title, searchQuery)}</Text>
        <Icon className="text-action-active text-[18px]">
          {open ? 'expand_more' : 'chevron_right'}
        </Icon>
      </Collapsible.Trigger>
      <Collapsible.Content className="c-collapsible-section__content">
        {children}
      </Collapsible.Content>
    </Collapsible.Root>
  )
}
